"use client";

import { Accessibility, X } from "lucide-react";
import { useEffect, useState } from "react";
import { AccessibilityControls } from "./accessibility-controls";

export function AccessibilityFab() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    // A11y adota o mesmo formato/cor do VLibras (quadrado arredondado, primary
    // blue) e fica empilhado logo acima dele. VLibras está em bottom 1.5rem
    // (24px) + height 40px = top edge em 64px. A11y em bottom 5rem (80px) deixa
    // 16px de respiro entre os dois.
    <div className="fixed right-6 bottom-20 z-40 flex flex-row-reverse items-end gap-3 md:hidden">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-label={
          open ? "Fechar controles de acessibilidade" : "Abrir controles de acessibilidade"
        }
        aria-expanded={open}
        aria-controls="a11y-controls-panel"
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary text-on-primary shadow-md transition-all hover:bg-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
      >
        {open ? (
          <X aria-hidden className="h-5 w-5" />
        ) : (
          <Accessibility aria-hidden className="h-5 w-5" />
        )}
      </button>

      {open && (
        <div
          id="a11y-controls-panel"
          className="flex items-center gap-1 rounded-lg bg-primary px-2 py-1.5 text-on-primary shadow-md"
        >
          <AccessibilityControls size="md" />
        </div>
      )}
    </div>
  );
}
